import theme from "@/theme";
import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  card: {
    bgcolor: "#fff",
    p: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "20px",
  },
  header: {
    height: 34,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerTextWrapper: {
    maxWidth: "430px",
    display: "flex",
    alignItems: "center",
  },

  headerText: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    color: (theme) => theme.palette.custom.blueGray600,
  },

  item: {
    whiteSpace: "nowrap",
  },

  watchBtn: {
    height: 34,
    borderRadius: "26px",
    px: "16px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    padding: "6px 8px 6px 12px",
  },
  titleRow: {
    // width: 756,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  company: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "130%",
    color: (theme) => theme.palette.custom.blueGray900,
  },
  priceBlock: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    minWidth: "235px",
  },
  price: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "28px",
  },
  upIcon: {
    width: 24,
    height: 24,
    color: "#008001",
  },
  priceChange: {
    whiteSpace: "nowrap",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "130%",
    color: "#008001",
  },

  chartContainerWrapper: {
    width: "100%",
    // border: "1px solid #eef2f8ff",
    borderRight: "1px solid #d9dadb",
    position: "relative",
    zIndex: 2,
    overflow: "hidden",
  },

  chartContainer: {
    width: "calc(100% + 95px)",
    // height: 246,
    zIndex: 1,
  },

  filters: {
    width: "100%",
    height: 34,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  filterText: {
    fontFamily: "Inter",
    fontSize: "16px",
    cursor: "pointer",
    width: "108px",
    textAlign: "center",
  },
  filterLine: {
    width: "100%",
    height: "2px",
    bgcolor: "#eee",
    position: "relative",
  },
  filterLineActive: {
    width: "90px",
    height: "2px",
    bgcolor: theme.palette.custom.mainBlue,
    position: "absolute",
    left: "0px",
    top: 0,
  },

  metricsRow: {
    minHeight: "36px",
    display: "flex",
    alignItems: "center",
    paddingTop: "20px",
    opacity: 1,
    flexWrap: "wrap",
  },
  metricItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    whiteSpace: "nowrap",
  },
  metricLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "16px",
    color: "#7D8690",
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  metricValue: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "16px",
    color: "#383C40",
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  metricDivider: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "16px",
    color: "#7D8690",
    whiteSpace: "nowrap",
  },
  metricLink: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "16px",
    color: "#2A2D31",
    textDecoration: "underline",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  descriptionBlock: {
    minHeight: "22px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  descriptionTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#2A2D31",
    textAlign: "left",
  },
  descriptionText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#52575D",
  },
  metricGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    whiteSpace: "nowrap",
  },
};
